// Light, dark, or whatever the system says. The choice lives in this browser only; styles.css
// reads it from data-theme on <html>.

import { useState } from "react";

export type Theme = "system" | "light" | "dark";

const KEY = "nsj-theme";

export function storedTheme(): Theme {
  try {
    const value = localStorage.getItem(KEY);
    return value === "light" || value === "dark" ? value : "system";
  } catch {
    return "system";
  }
}

/** `systemFallback` replaces "system", e.g. dark on the TV screen. */
export function applyTheme(theme: Theme, systemFallback: "light" | "dark" | null = null) {
  const resolved = theme === "system" ? systemFallback : theme;
  if (resolved) document.documentElement.dataset.theme = resolved;
  else delete document.documentElement.dataset.theme;
}

export function useTheme() {
  const [theme, setThemeState] = useState(storedTheme);
  function setTheme(next: Theme) {
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Private mode: the choice lasts until the page closes.
    }
    applyTheme(next);
    setThemeState(next);
  }
  return [theme, setTheme] as const;
}
